import { KesPipe } from './shared/kes.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { TreeModule } from 'angular-tree-component';
import { DatepickerComponent } from './shared/datepicker/datepicker.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule, TreeModule, AppRoutingModule, NgbModule.forRoot()
  ],
  declarations: [
    SidebarComponent, DatepickerComponent, KesPipe],
  exports: [KesPipe, SidebarComponent, CommonModule, DatepickerComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared.module.ts